import * as React from "react";
import {cs} from "../../../../../../../../react/chain-services";
import "./overview.scss";
import {Badge} from "../../../../../../common/design2/badge/badge";

export const Overview = ({onViewList, fileName, cass}) => cs(
    () => (
        <div className="overview-5jc">

            <div className="header">
                <div className="title">
                    <div className="label" xd-qa-type="label" xd-qa-name="CASS Result File Processed">
                        {cass?.status === "complete" ? (
                            "File Processed"
                        ) : (
                            "Processing File"
                        )}
                    </div>
                    <div className="file-name" xd-qa-type="label" xd-qa-name="CASS Result File Name">
                        {fileName}
                    </div>
                </div>

                <div className="sub-title" xd-qa-type="label" xd-qa-name="CASS Result File Processed Description">
                    {!cass || cass.status === "inProgress" ? (
                        `Checking CASS status. ${cass?.unCassedCount ?? "--"} addresses remains. Your mailing list is created, this CASS checking step is optional, you can close the this modal and continue with your order at any time.`
                    ) : cass.badCount ? (
                        "There are addresses that may require your attention. View results below."
                    ) : (
                        "All addresses are good"
                    )}
                </div>
            </div>

            <div className="box">
                <div className="status">
                    <div className="line">
                        {Badge({
                            color: "green",
                            text: `Good ${cass?.goodCount ?? "--"}`,
                            xdQaName: "CASS Result Good Count",
                        })}

                        <div className="text" xd-qa-type="label" xd-qa-name="CASS Result Included">
                            These will be <b>included</b> in your order.
                        </div>
                    </div>

                    {!!cass?.badCount && (
                        <div className="line">
                            {Badge({
                                color: "red",
                                text: `Failed ${cass?.badCount ?? "--"}`,
                                xdQaName: "CASS Result Warning Count",
                            })}

                            <div className="text" xd-qa-type="label" xd-qa-name="CASS Result Excluded">
                                This may be <b>excluded</b> from your order.
                            </div>
                        </div>
                    )}
                </div>

                <div className="actions">
                    <button {...{onClick: onViewList}} xd-qa-type="button" xd-qa-name="CASS Result View/Edit List">
                        VIEW/EDIT LIST
                    </button>
                </div>
            </div>
        </div>
    ),
);